import { render, staticRenderFns } from "./footerBottom.vue?vue&type=template&id=7471fdc1&"
import script from "./footerBottom.vue.ts?vue&type=script&lang=ts&"
export * from "./footerBottom.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports